import type { FaireProductEntity } from "../../entity_types/product";

export const p_edf8m7wq34: FaireProductEntity = {
  token: "p_edf8m7wq34",
  type: "product",
  name: "Silly Goose Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/a0196c8714db458595c0142c3b64a0ff9f58cb7291a1268860cd57cdef7eb8e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a3ea04bb3e2119590f072476e451ccba9705dc0bdcc5dc76d61dad8a86d2985d.jpeg",
    "https://cdn.faire.com/fastly/4cf6084fe3a32c02b68be30d62dc458243b1418098e855d3c053489593b67b4c.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/c481080c2b85333b1c34d429805f35464b7ac2274d5049bf7daa187e78ebc5af.jpeg",
    "https://cdn.faire.com/fastly/f465e18e9a36d3fb87962834ebda4693fdb0f1a369bf5d8c63c8b2994d422e73.jpeg"
  ],
  priceDollars: 6.75,
  description: "A sock for cute little weirdos, harmless chaos agents, and anyone who's just a minor inconvenience away from honking.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:51.287Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
